import React, { useState } from "react";
import Scrollspy from "react-scrollspy";
import { Link } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import {
  FiUser,
  FiBriefcase,
  FiFileText,
  FiPhoneOutgoing,
  FiHome,
  FiTarget,
  FiGrid,
  FiMessageSquare,
  FiServer,
} from "react-icons/fi";

const Header = () => {
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);

  return (
    <>
      {/* Header */}
      <div className="mob-header">
        <button className="toggler-menu" onClick={handleClick} aria-label="Abrir menú">
          <div className={click ? "active" : ""}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </button>
      </div>
      {/* End Header */}

      {/* nav bar */}
      <header className={click ? "header-left menu-open" : "header-left "}>
        <div className="scroll-bar">
          <div className="hl-top">
            <div className="hl-logo">
              <span>AD</span>
            </div>
          </div>
          {/* End htl-top */}

          <Scrollspy
            className="nav nav-menu"
            items={["inicio", "quienes-somos", "servicios", "por-que-elegirnos", "portafolio", "testimonios", "contacto"]}
            currentClassName="active"
            offset={-30}
          >
            <li>
              <a
                className="nav-link "
                href="#inicio"
                data-tooltip-id="INICIO"
                onClick={handleClick}
                aria-label="Inicio"
              >
                <FiHome />
                <Tooltip
                  id="INICIO"
                  place="right"
                  effect="float"
                >
                  <span>Inicio</span>
                </Tooltip>
              </a>
            </li>
            <li>
              <a
                className="nav-link"
                href="#quienes-somos"
                data-tooltip-id="QUIENES-SOMOS"
                onClick={handleClick}
                aria-label="Quiénes somos"
              >
                <FiUser />
                <Tooltip
                  id="QUIENES-SOMOS"
                  place="right"
                  effect="float"
                >
                  <span>Quienes somos</span>
                </Tooltip>
              </a>
            </li>
            <li>
              <a
                className="nav-link"
                href="#servicios"
                data-tooltip-id="SERVICIOS"
                onClick={handleClick}
                aria-label="Servicios"
              >
                <FiServer />
                <Tooltip
                  id="SERVICIOS"
                  place="right"
                  effect="float"
                >
                  <span>Servicios</span>
                </Tooltip>
              </a>
            </li>
            <li>
              <a
                className="nav-link"
                href="#por-que-elegirnos"
                data-tooltip-id="POR-QUE-ELEGIRNOS"
                onClick={handleClick}
                aria-label="Por qué elegirnos"
              >
                <FiTarget />
                <Tooltip
                  id="POR-QUE-ELEGIRNOS"
                  place="right"
                  effect="float"
                >
                  <span>Por qué elegirnos</span>
                </Tooltip>
              </a>
            </li>
            <li>
              <a
                className="nav-link"
                href="#portafolio"
                data-tooltip-id="PORTAFOLIO"
                onClick={handleClick}
                aria-label="Portafolio"
              >
                <FiGrid />
                <Tooltip
                  id="PORTAFOLIO"
                  place="right"
                  effect="float"
                >
                  <span>Portafolio</span>
                </Tooltip>
              </a>
            </li>
            <li>
              <a
                className="nav-link"
                href="#testimonios"
                data-tooltip-id="TESTIMONIOS"
                onClick={handleClick}
                aria-label="Testimonios"
              >
                <FiMessageSquare />
                <Tooltip
                  id="TESTIMONIOS"
                  place="right"
                  effect="float"
                >
                  <span>Testimonios</span>
                </Tooltip>
              </a>
            </li>
            <li>
              <a
                className="nav-link"
                href="#contacto"
                data-tooltip-id="CONTACTO"
                onClick={handleClick}
                aria-label="Contacto"
              >
                <FiPhoneOutgoing />
                <Tooltip
                  id="CONTACTO"
                  place="right"
                  effect="float"
                >
                  <span>Contacto</span>
                </Tooltip>
              </a>
            </li>
          </Scrollspy>
        </div>
      </header>
      {/* End Header */}
    </>
  );
};

export default Header;
